import { Location } from "@angular/common";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { DefaultService } from "src/app/services/default/default.service";
import { Webflow } from "src/app/utils/webflow";
import Swal from "sweetalert2";

@Component({
  selector: "app-payment-help",
  templateUrl: "./payment-help.component.html",
  styleUrls: ["./payment-help.component.scss"],
})
export class PaymentHelpComponent implements OnInit, AfterViewInit {
  loading: boolean = true;

  nbr_hours_to_cancel_booking_before_start!: number;
  nbr_hours_to_transfer_after_end_session!: number;

  constructor(
    private defaultService: DefaultService,
    private spinner: NgxSpinnerService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.get_setting();
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  get_setting() {
    this.spinner.show();
    this.defaultService
      .public_get_with_full_route("custom/settings")
      .subscribe(
        (res: any) => {
          this.nbr_hours_to_cancel_booking_before_start =
            res.nbr_hours_to_cancel_booking_before_start;
          this.nbr_hours_to_transfer_after_end_session =
            res.nbr_hours_to_transfer_after_end_session;
        },
        (err) => {}
      )
      .add(() => {
        this.loading = false;
        this.spinner.hide();
      });
  }

  back() {
    this.location.back();
  }
}
